import Axios from "@/plugins/axios";

class MediaApi {
    upload(formData) {
        return Axios.post('api/medias', formData);
    }
}

export default new MediaApi();
